import React from 'react';
import { Link } from 'react-router-dom';
import FoundersSection from '../components/FoundersSection';

const AllAboutUsPage = () => {
  const sections = [
    {
      title: 'Il Sito',
      desc: 'La nostra casa digitale',
      links: [
        { label: 'Homepage', to: '/', internal: true },
        { label: 'Il Progetto', to: '/hub', internal: true },
        { label: 'La Sede & Orari', to: '/sede', internal: true },
        { label: 'Formazione Digitale', to: '/formazione', internal: true },
        { label: 'Cittadino', to: '/cittadino', internal: true },
      ]
    },
    {
      title: 'Manifesto & Pitch',
      desc: 'Chi siamo e dove andiamo',
      links: [
        { label: 'Pitch TEDx', to: '/pitch', internal: true },
        { label: 'Video Promo', to: '/linksvideo', internal: true },
      ]
    },
    {
      title: 'Mail Enti & Fondazioni',
      desc: 'Template pronti da inviare',
      links: [
        { label: 'Email per Enti Pubblici', to: '/email', internal: true },
        { label: 'Contatti Istituzionali', to: '/contatti', internal: true },
      ]
    },
    {
      title: 'Brand Kit',
      desc: 'Loghi, risorse, identità visiva',
      links: [
        { label: 'Scarica Brand Kit', to: '/brand', internal: true },
        { label: 'Logo PNG', to: '/logo_final.png', internal: false },
        { label: 'Logo SVG', to: '/logo_aicovo.svg', internal: false },
      ]
    },
    {
      title: 'Merchandising',
      desc: 'Linea </ Total Black',
      links: [
        { label: 'T-Shirt Gallery', to: '/tshirt', internal: true },
      ]
    },
    {
      title: 'Dona',
      desc: 'Sostieni il primo Digital Hub Sociale',
      links: [
        { label: 'Dona Ora', to: '/dona', internal: true, highlight: true },
        { label: 'WhatsApp', to: 'https://wa.me/393273839782', internal: false },
      ]
    },
  ];

  return (
    <main data-testid="about-page" className="min-h-screen pt-24 pb-16">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="font-mono font-black text-[#00FF41] text-4xl mb-3 block" style={{ textShadow: '0 0 20px rgba(0,255,65,0.3)', letterSpacing: '4px' }}>&lt; /</span>
          <h1 className="text-3xl md:text-4xl font-black text-white mb-2">All About Us</h1>
          <p className="text-white text-sm font-mono font-bold">Tutto quello che serve, in un posto solo.</p>
        </div>

        {/* Fondatori */}
        <FoundersSection />

        <div className="space-y-8">
          {sections.map((s, i) => (
            <div key={i} data-testid={`about-section-${i}`} className="bg-[#0A0A0A] border border-zinc-800 rounded-lg p-6 hover:border-[#00FF41]/20 transition-colors">
              <div className="flex items-center gap-3 mb-4">
                <span className="font-mono font-black text-[#00FF41] text-sm" style={{ letterSpacing: '2px' }}>&lt; /</span>
                <div>
                  <h2 className="font-bold text-white text-lg">{s.title}</h2>
                  <p className="text-zinc-500 text-xs">{s.desc}</p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2">
                {s.links.map((l, j) => (
                  l.internal ? (
                    <Link key={j} to={l.to} data-testid={`about-link-${i}-${j}`}
                      className={`font-mono text-sm px-4 py-2 rounded-full border transition-all ${
                        l.highlight
                          ? 'bg-[#00FF41] text-black border-[#00FF41] font-bold hover:bg-[#33FF66]'
                          : 'border-zinc-700 text-zinc-300 hover:border-[#00FF41]/50 hover:text-[#00FF41]'
                      }`}>
                      {l.label}
                    </Link>
                  ) : (
                    <a key={j} href={l.to} target="_blank" rel="noopener noreferrer" data-testid={`about-link-${i}-${j}`}
                      className="font-mono text-sm px-4 py-2 rounded-full border border-zinc-700 text-zinc-300 hover:border-[#00FF41]/50 hover:text-[#00FF41] transition-all">
                      {l.label}
                    </a>
                  )
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* La Visione del Fondatore */}
        <div data-testid="about-fondatore" className="mt-20 mb-16">
          <div className="text-center mb-10">
            <span className="font-mono font-black text-[#00FF41] text-2xl mb-2 block">&lt;/ La Visione</span>
            <p className="text-zinc-400 text-sm">Pensieri di Francesco, ideatore di AI_COVO</p>
          </div>

          <div className="bg-[#0A0A0A] border border-zinc-800 rounded-lg p-8 relative">
            <span className="absolute top-4 left-6 font-mono text-[#00FF41] text-6xl opacity-20 leading-none">"</span>
            <div className="space-y-4 text-zinc-300 text-sm leading-relaxed pl-6">
              <p>Il nostro credo, la nostra missione è la <span className="text-white font-bold">conoscenza</span>, la <span className="text-white font-bold">consapevolezza</span>, l'informazione, l'essere edotti, avere a disposizione, conoscere, sapere tutti gli strumenti possibili che il mondo di oggi ci propone.</p>
              <p>Tutti, tutti, tutti — da sapere quali sono le erbe spontanee e commestibili che si possono trovare anche nel tuo giardino, a come dialogare con l'intelligenza artificiale, a come istruirla, a come entrare nei profitti, a come sapere essere la <span className="text-white font-bold">meglio parte di se stessi</span>.</p>
              <p>La nostra missione è riuscire a trovare negli altri tutte le attitudini e le peculiarità e le prospicienze e le presunzioni e tutte le attitudini possibili che un essere umano ha. Vagliandole nel caso tutte, tutte — dalla parte olistica, la parte scientifica, la parte tecnologica, la parte digitale, la parte sensoriale, la parte emozionale, la parte psicologica emotiva, la parte psicologica sensoriale, fino anche alla scienza, alla finanza, sapere qualsiasi cosa.</p>
              <p className="text-[#00FF41] font-mono font-bold text-base">La nostra missione è il sapere, il sapere e attuare. Più so, più fo. Più so, più faccio.</p>
              <p>Più so di sapere, più so di non sapere, diceva quello che non mi ricordo. Però il concetto è: <span className="text-white font-bold">io voglio sapere per fare, io voglio fare per sapere.</span></p>
              <p>E aggiungo un altro concetto basico: è la guerra al lavoro. O meglio, tradotto: è giusto che le persone facciano il lavoro che più gli piace fare — e aggiungo, estremizzando — anche quando gli piace fare e anche quando gli piace fare. Non è giusto che uno faccia il muratore otto, nove, dieci ore al giorno, per cinque giorni alla settimana, per trecentodieci giorni all'anno e magari non gli piace. Per cosa? <span className="text-white font-bold">Non è possibile.</span></p>
              <p className="text-zinc-500 italic">Questo è un primo punto vocale che esprimo, ma ce ne saranno altri.</p>
            </div>
            <p className="text-right mt-6 font-mono text-[#00FF41] text-sm font-bold">— Francesco, Ideatore di AI_COVO</p>
          </div>
        </div>

        {/* Strategia Digitale - Investitori */}
        <div className="mt-20 mb-8">
          <div className="text-center mb-12">
            <span className="font-mono font-black text-[#00FF41] text-2xl mb-2 block">&lt;/ Strategia Digitale</span>
            <p className="text-zinc-400 text-sm">Le persone vivono il digitale. Noi ci siamo.</p>
          </div>

          {/* Grafico Finanziamento */}
          <div data-testid="about-pie-chart" className="bg-[#0A0A0A] border border-zinc-800 rounded-lg p-6 mb-8">
            <h3 className="font-bold text-white text-lg mb-4 flex items-center gap-2">
              <span className="font-mono text-[#00FF41] text-sm" style={{ letterSpacing: '2px' }}>&lt; /</span>
              Piano Finanziamento — Obiettivo €88.750
            </h3>
            <img src="/grafico_finanziamento.png" alt="Grafico Finanziamento AI_COVO" className="w-full max-w-lg mx-auto rounded-lg" />
          </div>

          {/* SEO & Google Ads */}
          <div data-testid="about-seo-section" className="bg-[#0A0A0A] border border-zinc-800 rounded-lg p-6 mb-8">
            <h3 className="font-bold text-white text-lg mb-2 flex items-center gap-2">
              <span className="font-mono text-[#00FF41] text-sm" style={{ letterSpacing: '2px' }}>&lt; /</span>
              SEO & Google Ads — 70 Keyword Strategiche
            </h3>
            <p className="text-zinc-500 text-xs mb-6">Meta tags, JSON-LD, Open Graph implementati. Campagne pronte al lancio.</p>

            {[
              { cat: 'Brand & Progetto', color: '#00FF41', keys: ['ai covo colle val d\'elsa', 'digital hub sociale italia', 'hub sociale toscana', 'primo hub sociale italia', 'crowdfunding sociale toscana', 'aicoa associazione culturale'], vol: '1.200', cpc: '€0.15', priority: 'DIFESA' },
              { cat: 'Doposcuola & Formazione', color: '#33FF66', keys: ['doposcuola colle val d\'elsa', 'doposcuola gratuito toscana', 'formazione digitale toscana', 'corsi digitali gratuiti', 'alfabetizzazione digitale anziani', 'corsi spid anziani', 'academy digitale toscana'], vol: '8.400', cpc: '€0.08', priority: 'ALTO ROI' },
              { cat: 'Inclusione Sociale', color: '#66FF88', keys: ['inclusione sociale toscana', 'inclusione digitale italia', 'spazi pubblici inclusivi', 'volontariato digitale toscana', 'terzo settore toscana', 'progetti sociali innovativi'], vol: '5.600', cpc: '€0.10', priority: 'ALTO ROI' },
              { cat: 'Donazioni & Crowdfunding', color: '#00CC33', keys: ['crowdfunding 1 euro', 'donazione deducibile', 'donazioni deducibili 100%', 'sponsor aziende terzo settore', 'raccolta fondi digitale', 'crowdfunding gamificato'], vol: '12.000', cpc: '€0.22', priority: 'CONVERSIONE' },
              { cat: 'Territorio & Comune', color: '#009922', keys: ['colle val d\'elsa servizi', 'smart city toscana', 'innovazione sociale comuni', 'pro loco colle val d\'elsa'], vol: '3.200', cpc: '€0.06', priority: 'LOCALE' },
              { cat: 'Competitor & Generiche', color: '#006611', keys: ['come donare online sicuro', 'migliori progetti sociali italia', 'hub culturale italia', 'centri educativi bambini toscana'], vol: '22.000', cpc: '€0.35', priority: 'AWARENESS' },
            ].map((g, i) => (
              <div key={i} className="mb-6 last:mb-0">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <span className="w-3 h-3 rounded-full" style={{ background: g.color }} />
                    <span className="font-bold text-white text-sm">{g.cat}</span>
                    <span className="font-mono text-[10px] px-2 py-0.5 rounded-full border" style={{ borderColor: g.color, color: g.color }}>{g.priority}</span>
                  </div>
                  <div className="flex gap-4 text-xs font-mono">
                    <span className="text-zinc-400">Vol: <span className="text-white">{g.vol}/mese</span></span>
                    <span className="text-zinc-400">CPC: <span className="text-[#00FF41]">{g.cpc}</span></span>
                  </div>
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {g.keys.map((k, j) => (
                    <span key={j} className="text-[11px] font-mono px-2 py-1 rounded bg-zinc-900 text-zinc-400 border border-zinc-800">{k}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Riepilogo numeri */}
          <div data-testid="about-metrics" className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { n: '70', label: 'Keyword SEO', sub: 'indicizzate' },
              { n: '52.400', label: 'Ricerche/mese', sub: 'volume stimato' },
              { n: '€0.15', label: 'CPC medio', sub: 'costo per click' },
              { n: '6', label: 'Cluster Ads', sub: 'campagne pronte' },
            ].map((m, i) => (
              <div key={i} className="bg-[#0A0A0A] border border-zinc-800 rounded-lg p-4 text-center hover:border-[#00FF41]/30 transition-colors">
                <p className="font-mono font-black text-2xl text-[#00FF41]" style={{ textShadow: '0 0 10px rgba(0,255,65,0.3)' }}>{m.n}</p>
                <p className="font-bold text-white text-xs mt-1">{m.label}</p>
                <p className="text-zinc-600 text-[10px]">{m.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default AllAboutUsPage;
